export { NotificationDetails } from './notification-details';
